// TODO
// I think we should transfer all
// states that is related to user authentication
// here instead of putting them in user reducer 
import {
  VALIDATE_USER_RESET_PASSWORD_TOKEN_START,
  VALIDATE_USER_RESET_PASSWORD_TOKEN_DONE,
  VALIDATE_USER_RESET_PASSWORD_TOKEN_FAILED,
  USER_RESET_PASSWORD_TOKEN_EXPIRED,
  RESET_USER_PASSWORD_START,
  RESET_USER_PASSWORD_DONE,
  RESET_USER_PASSWORD_FAILED,
} from "../actionTypes";

const initialState = {
  isValidatingResetPasswordToken: false,
  isResetPasswordTokenExpired: false,
  isResettingPassword: false,
  resetUserPasswordSuccess: false,
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case VALIDATE_USER_RESET_PASSWORD_TOKEN_START:
      return {
        ...state,
        isValidatingResetPasswordToken: true,
      };
    case VALIDATE_USER_RESET_PASSWORD_TOKEN_DONE:
      return {
        ...state,
        isValidatingResetPasswordToken: false,
      };
    case VALIDATE_USER_RESET_PASSWORD_TOKEN_FAILED:
      return {
        ...state,
        isValidatingResetPasswordToken: false,
      };
    case USER_RESET_PASSWORD_TOKEN_EXPIRED:
      return {
        ...state,
        isValidatingResetPasswordToken: false,
        isResetPasswordTokenExpired: true,
      };
    case RESET_USER_PASSWORD_START:
      return {
        ...state,
        isResettingPassword: true,
        resetUserPasswordSuccess: false,
      };
    case RESET_USER_PASSWORD_DONE:
      return {
        ...state,
        isResettingPassword: false,
        resetUserPasswordSuccess: true,
      };
    case RESET_USER_PASSWORD_FAILED:
      return {
        ...state,
        isResettingPassword: false,
        resetUserPasswordSuccess: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/reducers/authentication.js